<template>
  <div>
    <page-content>
      <ntm-block title="Logo" :init-collapse="false">
        <template slot="options">
          <span>{{ $t('ratio') }}: <span class="font-weight-bold">2:1</span>, {{ $t('size') }}: <span class="font-weight-bold">500x250</span></span>
        </template>
        <ntm-crop v-if="model.uuid" entity-type="settings" :aspect-ratio="2/1" :max-width="500" :max-height="250"
                  :entity-uuid="model.uuid" conversion="lg" collection="logo"></ntm-crop>
      </ntm-block>

      <ntm-block :title="$tc('crest')" :init-collapse="false">
        <template slot="options">
          <span>{{ $t('ratio') }}: <span class="font-weight-bold">1:1</span>, {{ $t('size') }}: <span class="font-weight-bold">200x200</span></span>
        </template>
        <ntm-crop v-if="model.uuid" entity-type="settings" :entity-uuid="model.uuid" conversion="lg" collection="crest"
                  :circle="true"></ntm-crop>
      </ntm-block>

      <form @submit.prevent="onSubmit()">
        <ntm-block>
          <formly-form :form="form" :model="model" :fields="brandingFields"></formly-form>
          <button class="btn btn-success push-15">{{ $t('save') }}</button>
        </ntm-block>
      </form>
    </page-content>
  </div>
</template>

<script>
import SettingsService from '../../services/settings.service'
import formDefinition from './formDefinition'
import UserService from '@/services/user.service'
import store from '@/store'

export default {
  data () {
    return {
      model: {},
      form: {},
      brandingFields: [...formDefinition.brandingFields]
    }
  },
  beforeRouteEnter (to, from, next) {
    SettingsService.index().then((response) => {
      next(vm => vm.setData(response.data))
    })
  },
  methods: {
    setData (data) {
      this.model = data
      if (!data.hasLinkedWebsites) {
        this.brandingFields = this.brandingFields.filter(f => f.key !== 'multi_league_select_title')
      }
    },
    onSubmit () {
      SettingsService.storeBranding(this.model).then(async () => {
        await UserService.getUser().then((response) => {
          store.commit('currentUser', response.data)
        })
        this.form.$errors = {}
        await this.$store.dispatch('getClient')
        this.$store.commit('loaded')
      }).catch((err) => {
        this.form.$errors = err.response.data.errors
      })
    }
  }
}
</script>
